import React, { useState } from 'react';
import { Building2 } from 'lucide-react';

// Google's favicon service — keyless. Returns the site icon for a domain.
// We strip any protocol/path so "https://acme.com/x" and "acme.com" both work.
const faviconUrl = (domain) => {
  if (!domain) return null;
  const clean = String(domain)
    .replace(/^https?:\/\//i, '')
    .replace(/\/.*$/, '')
    .trim();
  if (!clean) return null;
  return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(clean)}&sz=64`;
};

// A company's favicon with a graceful fallback to the building icon when there's
// no domain, or the favicon fails to load (blocked, missing, offline).
const CompanyLogo = ({
  domain,
  size = 40,
  rounded = 'rounded-xl',
  bg = 'bg-green-500/20',
  iconColor = 'text-green-500',
}) => {
  const [failed, setFailed] = useState(false);
  const url = faviconUrl(domain);
  const showImg = url && !failed;
  const inner = Math.round(size * 0.55);

  return (
    <div
      className={`flex items-center justify-center overflow-hidden shrink-0 ${rounded} ${bg}`}
      style={{ width: size, height: size }}
    >
      {showImg ? (
        <img
          src={url}
          alt=""
          width={inner}
          height={inner}
          loading="lazy"
          onError={() => setFailed(true)}
        />
      ) : (
        <Building2 className={iconColor} style={{ width: size * 0.5, height: size * 0.5 }} />
      )}
    </div>
  );
};

export default CompanyLogo;
